import React, { memo } from 'react'
import { useDispatch } from 'react-redux'

import useUserPermission from 'lib/hooks/useUserPermission'
import { ENDPOINTS } from 'constants/endpoints'
import { changeLocation } from 'store/app/actions'
import i18n from 'i18n'

import { Wrapper } from './styles'
import { LinkLabel } from 'components/atoms'
interface Props {
  urlName: string
  pageName: string
  isDisabledReload?: boolean
  onHandleReload?: () => void
  featureId: number
}

const RedirectToMasterPageLink = ({ urlName, pageName, onHandleReload, isDisabledReload, featureId }: Props) => {
  const { permissions } = useUserPermission(featureId)
  const dispatch = useDispatch()

  return (
    <Wrapper>
      <LinkLabel
        onClick={() => dispatch(changeLocation(`/${ENDPOINTS.MASTER}/${urlName}/new`))}
        disabled={!permissions.isEdit}
        showTooltipMessage={!permissions.isEdit ? i18n.t('common.actions.no_permission') : undefined}
        className="link"
      >
        {i18n.t('components.AutoCompleteSelect.add_new_item_link', {
          itemName: pageName,
        })}
      </LinkLabel>
      <LinkLabel className="link" disabled={isDisabledReload} onClick={onHandleReload}>
        {i18n.t('components.AutoCompleteSelect.reload_options', {
          itemName: pageName,
        })}
      </LinkLabel>
    </Wrapper>
  )
}

export default memo(RedirectToMasterPageLink)
